import { FeatureFlag } from 'enums/featureFlag.enums';
import { AppRoutes } from 'routes/routes.enums';
import { persistor } from 'store';

export const switchToPrequalificationV2 = async (route: AppRoutes | string) => {
  localStorage.setItem(FeatureFlag.IsNewPrequalificationEnabled, 'true');

  await persistor.flush();

  window.location.replace(route);
};
